class InstancePool<T> {
  private allInstances: Array<T> = [];
  private availableInstances: Array<T> = [];

  /**
   * Add an instance to the pool
   * @param obj
   * @param isAvailable make it available when true (default: false)
   * @returns
   */
  add(obj: T, isAvailable = false) {
    this.allInstances.push(obj);

    if (isAvailable) {
      this.availableInstances.push(obj);
    }

    return obj;
  }

  /**
   * Check if there are still available instances in the pool.
   * @returns
   */
  isEmpty(): boolean {
    return this.availableInstances.length === 0;
  }

  /**
   * Pops one instance from the pool.
   * @throw when the pool of available instances is empty. Use `.isEmpty()` to test.
   * @returns
   *
   */
  pop(): T {
    if (this.isEmpty()) {
      throw new Error("No more instances available ini the pool.");
    }

    return <T>this.availableInstances.pop();
  }

  /**
   * Make all the instances available again
   */
  init() {
    this.availableInstances = this.allInstances.slice();
  }

  /**
   * Remove all elements
   */
  reset() {
    this.availableInstances = [];
    this.allInstances = [];
  }
}

export { InstancePool };
